export default __webpack_public_path__ + "e3246ec9a1b691841bc4f2dd77841b4d.jpg";